module.exports = __webpack_public_path__ + "static/media/bantuweb-add-translation.dd0f63a6.png";